import { toFileKey } from "shared/api/awsS3";
import { apiClient } from "shared/api/client";

/** HGU샵(shops) 도메인 API. */
// 어드민은 제휴중/종료/숨김 상관없이 전체를 불러오므로 all=true로 요청한다.
export const fetchShops = async () => {
  const response = await apiClient.get("/shops", { params: { all: true } });
  return response.data;
};

export const getShopKorEng = async (shopId) => {
  const response = await apiClient.get(`/admin/shopsKorEng/${shopId}`);
  return response.data;
};

export const createShop = async (data) => {
  const response = await apiClient.post("/shops", data);
  return response.data;
};

export const updateShop = async (id, data) => {
  const response = await apiClient.patch(`/shops/${id}`, data);
  return response.data;
};

export const deleteShop = async (id) => {
  await apiClient.delete(`/shops/${id}`);
};

// 메인 노출(pin) 지정/해제.
// shops PATCH는 미전송 필드를 null로 덮어쓰므로(ShopForm 참고) pin만 보내면 안 된다.
// 각 항목의 전체 레코드를 불러와 pin만 바꿔 수정 저장과 동일한 페이로드로 되돌려 보낸다.
// 서버는 PATCH /shops/{단일 id}만 받으므로 다중 선택은 id별로 개별 요청한다.
export const setShopMainExposure = async (ids, expose) => {
  const idList = Array.isArray(ids) ? ids : [ids];
  await Promise.all(
    idList.map(async (id) => {
      const shop = await getShopKorEng(id);
      await updateShop(id, {
        name: shop.name,
        imageKey: toFileKey(shop.image),
        hide: shop.hide ?? false,
        pin: expose,
        // 레거시 데이터의 inProgress=null은 제휴중(true)으로 간주.
        inProgress: shop.inProgress ?? true,
        title: shop.title,
        content: shop.content,
        category: shop.category,
        engTitle: shop.engTitle,
        engContent: shop.engContent,
      });
    }),
  );
};
